import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageWebp from './images/skateboarding-child.webp';
import financialPlanningImageMobileWebp from './images/skateboarding-child-mobile.webp';
// styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='disability-insurance-financial-planning'
      moduleName='financial-planning-module'
      moduleVariant='A'
      reverseContent={false}
      // content
      subHeadingText={<>Disability insurance: a key part of a smart <WidowBlock>financial plan</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            When you work with Northwestern Mutual, we listen to the goals you have and design a personalized financial plan specifically for your life. Disability insurance will likely be an important part of that plan, giving you:
          </Typography>
          <BulletedListStyled
            disableBottomPadding
            bulletType='checkmark'
            bulletedListData={[
              { bulletText: 'A policy with a monthly benefit that can be customized to your life and needs' },
              { bulletText: (<>Protection for the financial progress you&#39;ve made so far</>) },
              { bulletText: (<>Income when you need it most so your lifestyle doesn&#39;t get detailed</>) },
              { bulletText: 'Dividends that can be used to reduce your premiums over time' },
            ]}
          />
          <Link
            id='financial-planning-section-cta'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/financial-planning/'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='A father helping his young daughter skateboard'
      imageSrcDefault={financialPlanningImageWebp.toString()}
      imageSrcMobile={financialPlanningImageMobileWebp.toString()}
    />
  );
};
